import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { LocaleSwitch, Logo } from 'containers/misc'
import styles from './header.styl'
import getHeaderColorStyle from 'helpers/getHeaderColorStyle'

const headerColorStyle = getHeaderColorStyle()

export default class HeaderPlain extends Component {
  static propTypes = {
    // user: PropTypes.object,
    // modal: PropTypes.func,
    showLocale: PropTypes.bool
  }

  static defaultProps = {
    showLocale: true
  }

  render() {
    const { showLocale } = this.props

    return (
      <header
        className={`${styles.header} ${styles.headerSimple}`}
        style={headerColorStyle}
      >
        <div className={styles.logo}>
          <Logo className={styles.img} />
        </div>

        {showLocale && (
          <div className={styles.locale}>
            <LocaleSwitch />
          </div>
        )}

        <div className={styles.separators}>
          <div className={styles.separator1} />
          <div className={styles.separator2} />
          <div className={styles.separator3} />
          <div className={styles.separator4} />
          <div className={styles.separator5} />
        </div>
      </header>
    )
  }
}
